const nameFilters = new Set<string>([
    'NOME VALIDO',
    'VALID NAME',
    'NOMBRE VALIDO',
]);

export const isNameFilter = (name: string) => nameFilters.has(name);
